import { styled } from "@washingtonpost/wpds-theme";
import React from "react";
import PropTypes from "prop-types";
import { useStickyVideoContext } from "../contexts/StickyVideoContext";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";

const StyledFullScreenWrapper = styled("div", {});

export const useCalcCss = ({
  isFullscreen,
  liveEventEnded,
  isOpenSticky,
  aspectRatio,
  stickyPropStyles
}) => {
  const fullScreenStyles = {
    display: liveEventEnded ? "none" : "flex",
    alignItems: "center"
  };

  const isVertical = aspectRatio > 1;

  const stickyStyles = {
    width: "450px",
    position: "fixed",
    inset: "auto 20px 20px auto",
    top: "auto",
    right: 20,
    bottom: 20,
    left: "auto",
    zIndex: "100",
    aspectRatio: aspectRatio,
    transition: "width 0.5s ease, height 0.5s ease",
    height: isVertical
      ? `${450 * (1 / aspectRatio)}px`
      : `${450 * aspectRatio}px`,
    backgroundColor: "$gray0-static",
    ...stickyPropStyles,
    "@md": {
      width: "300px",
      height: isVertical
        ? `${300 * (1 / aspectRatio)}px`
        : `${300 * aspectRatio}px`,
      ...stickyPropStyles?.["@md"]
    },
    "@sm": {
      width: "250px",
      bottom: 150,
      height: isVertical
        ? `${250 * (1 / aspectRatio)}px`
        : `${250 * aspectRatio}px`,
      ...stickyPropStyles?.["@sm"]
    }
  };

  return {
    ...(isFullscreen && fullScreenStyles),
    ...(liveEventEnded && { display: "none" }),
    ...(isOpenSticky && stickyStyles)
  };
};

export const FullScreenWrapper = ({
  controlWrapperClassName,
  liveEventEnded,
  aspectRatio,
  children,
  stickyStyles
}) => {
  const { isOpenSticky } = useStickyVideoContext();
  const { fullScreenWrapper, isFullscreen } = useOrcaCommonContext();

  const css = useCalcCss({
    isFullscreen,
    liveEventEnded,
    isOpenSticky,
    aspectRatio,
    stickyPropStyles: stickyStyles
  });

  return (
    <StyledFullScreenWrapper
      data-testid="full-screen-wrapper"
      ref={fullScreenWrapper}
      className={controlWrapperClassName}
      css={css}
    >
      {children}
    </StyledFullScreenWrapper>
  );
};

FullScreenWrapper.propTypes = {
  fullScreenWrapper: PropTypes.object,
  controlWrapperClassName: PropTypes.string,
  isFullscreen: PropTypes.bool,
  liveEventEnded: PropTypes.bool,
  isOpenSticky: PropTypes.bool,
  aspectRatio: PropTypes.number,
  children: PropTypes.node.isRequired,
  stickyStyles: PropTypes.object
};
